import {
  sendGoogleEvent,
  sendAmplitudeEvent,
} from '@html/_common/utils';

export default class AOFaqSearch {
  constructor(questions, tourId) {
    this.form = null;
    this.searchField = null;
    this.initialSearch = true;
    this.typesList = null;
    this.typeId = null;
    this.questions = questions;
    this.tourId = tourId;
  }

  initiate() {
    this.form = $('.js-ao-tour-faq__search-form');
    this.searchField = this.form.find('input[name=search]');
    this.typesList = this.form.find('.js-ao-tour-faq__search-form-types');

    this.searchField.on('input propertychange paste', (event) => {
      const $input = $(event.currentTarget);
      const $types = $('.ao-tour-faq__search-form-types-item');
      this.typeId = null;
      if ($input.val() === '' && $types.length > 0) {
        this.typesList.show();

        if (!this.initialSearch) {
          this.find();
        }
      } else {
        this.typesList.hide();
      }
    });

    this.searchField.on('focus', (event) => {
      const $input = $(event.currentTarget);
      const $types = $('.ao-tour-faq__search-form-types-item');
      if (($input.val() === '' || this.typeId) && $types.length > 0) {
        this.typesList.show();
      }
    });

    $(document).click((e) => {
      if (!$(e.target).closest(this.typesList).length
        && !$(e.target).closest(this.searchField).length) {
        this.typesList.hide();
      }
    });

    this.typesList.on('click', 'li', (e) => {
      e.preventDefault();
      const $clickedElement = $(e.currentTarget);

      let typeName = $clickedElement.text();

      this.searchField.val(typeName);
      this.typeId = parseInt($clickedElement.data('type') || 0, 10);
      this.typesList.hide();

      if (this.typeId === '10') {
        typeName = 'Operator';
      }
      sendGoogleEvent('Q&A Search', 'Select Category', typeName);

      this.form.submit();
    });

    this.form.submit((e) => {
      e.preventDefault();

      if (this.searchField.val().trim() === '') {
        this.searchField.focus().addClass('ao-tour-faq__search-form-input--shake');
        setTimeout(() => {
          this.searchField.removeClass('ao-tour-faq__search-form-input--shake');
        }, 1000);
        return;
      }

      sendAmplitudeEvent({
        ampEventName: 'tdp_faq_searched',
        tdp_faq_search: this.searchField.val(),
      });

      this.find();
    });
  }

  find() {
    this.initialSearch = !(this.typeId || this.searchField.val());
    this.questions.page = 1;
    this.questions.typeId = this.typeId;
    this.questions.searchPhrase = this.searchField.val();
    this.questions.loadQuestions();

    sendGoogleEvent(
      'Q&A Search',
      'Search',
      this.searchField.val(),
      {
        ampEventName: 'tdp_faq_clicked',
        tdp_faq_clicked_search: this.searchField.val(),

      },
    );
  }
}
